import { render, staticRenderFns } from "./PageBanner.vue?vue&type=template&id=431955e8&scoped=true"
import script from "./PageBanner.vue?vue&type=script&lang=js"
export * from "./PageBanner.vue?vue&type=script&lang=js"
import style0 from "./PageBanner.vue?vue&type=style&index=0&id=431955e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "431955e8",
  null
  
)

export default component.exports